import Filter from '../Filter';
import { getPaginatedEvents, getPaginatedMasterEvents } from '../../api/user/EventApi';

export default class EventFilter extends Filter {
  /**
   * @param {Object} data
   * @param {Object} options
   * @param {boolean} options.isMaster - If true, use master events API
   */
  constructor(data, options = {}) {
    super(data);

    // Filter mode
    this._isMaster = options.isMaster ?? false;

    // Date range filter (for /events page)
    this.start_date = data?.start_date ?? null;
    this.end_date = data?.end_date ?? null;

    // Title search (for /master/events page)
    this.title = data?.title ?? '';

    // Default limit
    this.limit = data?.limit ?? (this._isMaster ? 50 : 10);
  }

  get key() {
    return this._isMaster ? 'master_events' : 'events';
  }

  get paginatedFetcher() {
    if (this._isMaster) {
      return async () => await getPaginatedMasterEvents(this);
    }
    return async () => await getPaginatedEvents(this);
  }

  /**
   * Set date range
   * @param {Date} startDate
   * @param {Date} endDate
   */
  setDateRange(startDate, endDate) {
    this.start_date = this.formatDate(startDate);
    this.end_date = this.formatDate(endDate);
  }

  /**
   * Format date to YYYY-MM-DD string
   * @param {Date} date
   * @returns {string}
   */
  formatDate(date) {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
